import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import Formsy from "formsy-react";
import { Row } from "react-bootstrap";
import { Input } from "formsy-react-components";

import zxcvbn from "zxcvbn";

class ResetPassForm extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      canSubmit: false,
      newPassword: "",
      verifyPassword: "",
      strength: -1
    };
    this.minStrength = 4;
  }

  getPasswordStrength = (pw) => {
    const strength = zxcvbn(pw).score;
    const re = new RegExp(/[!@#$%^&*(),.?":{}|<>]/gi);
    if (re.test(pw)) {
      return strength;
    }
    return strength - 1;
  };

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
      strength:
        field === "newPassword"
          ? this.getPasswordStrength(value)
          : this.state.strength
    });
  };

  enableButton = () => {
    if (
      this.state.strength >= this.minStrength &&
      this.state.newPassword === this.state.verifyPassword
    ) {
      this.setState({ canSubmit: true });
    } else {
      this.setState({ canSubmit: false });
    }
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  submit = (model) => {
    this.props.onSave(model);
  };

  render() {
    const { strength } = this.state;
    return (
      <Formsy
        ref={(ref) => (this.form = ref)}
        className="reset form"
        onValidSubmit={this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
      >
        <h1>Reset Password</h1>
        <div className="strength-meter mt-2">
          <div className="strength-meter-fill" data-strength={strength} />
        </div>
        <Input
          formNoValidate
          required
          type="password"
          name="newPassword"
          label="Password"
          placeholder="New Password"
          onChange={this.handleChange}
          value={this.state.newPassword}
        />
        <Input
          formNoValidate
          required
          type="password"
          name="verifyPassword"
          label="Confirm Password"
          placeholder="Confirm Password"
          validations="equalsField:newPassword"
          validationError="Passwords do not match."
          onChange={this.handleChange}
          value={this.state.verifyPassword}
        />
        <Row className="text-center footer">
          <Link className="btn btn-cancel" to="/">
            Cancel
          </Link>
          <input
            className="btn btn-success"
            type="submit"
            disabled={!this.state.canSubmit}
            value={this.props.saving ? "Resetting... " : "Reset"}
          />
        </Row>
      </Formsy>
    );
  }
}

ResetPassForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired
};

export default ResetPassForm;
